// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Link, useParams } from "react-router-dom";
import { ROUTE_DEFINITIONS, getPath } from "../../routes/routes";
import { Theme, createStyles, makeStyles } from "@material-ui/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { TestRunParams } from "./TestRunConstants";
import { cx } from "style/utils";
import { fbt } from "fbt";
import { useTestRunConfig } from "./useTestRunConfig";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "inline-flex",
      clear: "both",
      float: "right",
    },
    floatLeft: {
      float: "left",
    },
    large: {
      fontSize: "19px",
    },
    nextLinkIcon: {
      width: "32px",
      height: "26px",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

export interface NextStepLinkProps {
  floatLeft?: boolean;
  large?: boolean;
  text?: string;
  to?: string;
  toNav?: string;
  returnStep?: boolean;
}
export default (props: NextStepLinkProps) => {
  const { step, testRunUID } = useParams<TestRunParams>();
  const {
    getNextDefaultStep,
    getNextStepOfType,
    getPreviousStep,
  } = useTestRunConfig();
  const classes = useStyle();
  const { floatLeft, large, text, to, toNav, returnStep } = props;

  if (to && toNav) {
    throw new Error(
      "NextStepLink cannot accept both 'to' and 'toNav' at the same time."
    );
  }
  let nextPath = to;
  if (!nextPath) {
    let destinationStep: string | undefined;

    if (returnStep) {
      destinationStep = getPreviousStep({
        currentStepName: step,
      });
    } else if (toNav) {
      destinationStep = getNextStepOfType({
        currentStepName: step,
        nextStepType: toNav,
      });
    } else {
      destinationStep = getNextDefaultStep({
        currentStepName: step,
      });
    }

    if (destinationStep === undefined) {
      throw new Error("NextStepLink cannot find a step to go to.");
    }

    nextPath = getPath(ROUTE_DEFINITIONS.PERFORMTEST, {
      params: {
        ":testRunUID": testRunUID,
        ":step": destinationStep!,
      },
    });
  }

  return (
    <Link
      to={nextPath}
      className={cx(
        classes.root,
        { [classes.floatLeft]: !!floatLeft },
        { [classes.large]: !!large }
      )}
    >
      {text || (
        <fbt desc="link to another step" project="audere">
          Continue
        </fbt>
      )}
      <span className={classes.nextLinkIcon}>
        <FontAwesomeIcon icon="arrow-right" />
      </span>
    </Link>
  );
};
